export const numberFormatter = (value: number) => {
  if (!value) return '0';
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const numberParser = (value: number) => {
  if (value < 0 || isNaN(value)) return '';
  return `${value}`.replace(/\./g, ',');
};

export const urlEmbed = (url: string) => {
  const igre = url.split('watch?v=');
  const src = `${igre[0]}/embed/${igre?.[1]}?showinfo=0&controls=0&autoplay=1`;
  return src;
};

export const formatBytes = (bytes?: number) => {
  if (!bytes || bytes <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const idx = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const val = bytes / Math.pow(1024, idx);
  const fixed = idx === 0 ? 0 : val >= 10 ? 0 : 1;
  return `${val.toFixed(fixed)} ${units[idx]}`;
};

export function getDescendantProp(obj: any, desc: Array<string>) {
  return desc.reduce((a, b) => a?.[b], obj);
}

export function removeVietnameseTones(str: string = '') {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  str = str.replace(/Đ/g, 'D');
  // Some system encode vietnamese combining accent as individual utf-8 characters
  // Some encodings store tone marks and vowel marks as separate characters, so these two lines handle that.
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // tone marks
  str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // vowel marks
  // Remove extra spaces
  // Remove repeated spaces
  str = str.replace(/ + /g, ' ');
  str = str.trim();
  // Remove punctuations
  // Remove punctuation and special characters
  str = str.replace(
    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    ' ',
  );
  return str;
}

export function randomChar(length: number) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export function indexToChar(index: number) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

  if (index >= characters.length) {
    return randomChar(2);
  }
  return characters.charAt(index);
}

export function formatRegisteredDate(value?: string) {
  if (!value) return "--"

  return new Intl.DateTimeFormat("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(new Date(value))
}

export function formatDateTime(value?: string | null) {
  if (!value) return "--"

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return "--"

  return `${date.toLocaleTimeString("vi-VN", {
    hour: "2-digit",
    minute: "2-digit",
  })}, ${date.toLocaleDateString("vi-VN")}`
}

export function formatFileSize(size?: number | null) {
  if (!size || size <= 0) return "--"

  if (size < 1024) return `${size} B`
  if (size < 1024 * 1024) return `${Math.round(size / 1024)} KB`

  return `${(size / 1024 / 1024).toFixed(1)} MB`
}

export function formatNotificationTime(createdAtUtc: string, compact = false) {
  const date = new Date(createdAtUtc);
  const diffInMinutes = Math.max(0, Math.floor((Date.now() - date.getTime()) / 60000));
  if (diffInMinutes < 1) return 'Vừa xong';
  if (diffInMinutes < 60) return compact ? `${diffInMinutes} phút trước` : `${diffInMinutes} phút trước`;

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    if (compact) {
      return `Hôm nay, ${date.toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' })}`;
    }

    return `${diffInHours} giờ trước`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) return `${diffInDays} ngày trước`;

  return new Intl.DateTimeFormat('vi-VN', {
    day: '2-digit',
    month: '2-digit',
    year: compact ? undefined : 'numeric',
  }).format(date);
}
